import { ApiUrl } from "../utils/modules";
import { header } from "../utils/modules";

class SignalementServices {
  constructor(api) {
    this.api = api;
  }
  create(data) {
    const headers =
      data instanceof FormData ? { "Content-Type": "multipart/form-data" } : {};
    return this.api.post(ApiUrl + "signalement?source=signalement", data, {
      headers,
    });
  }

  getAll() {
    return this.api.get(ApiUrl + "signalement", {
      ...header("json"),
    });
  }

  getOne(id, articleSignaleur) {
    return this.api.get(ApiUrl + `signalement/${id}`, {
      idSignaleur: articleSignaleur || null,
    });
  }

  delete(id) {
    return this.api.delete(ApiUrl + `signalement/${id}`);
  }

  update(id, data) {
    const headers =
      data instanceof FormData ? { "Content-Type": "multipart/form-data" } : {};
    return this.api.put(ApiUrl + `signalement/${id}`, data, { headers });
  }

  signalementRecap(id) {
    return this.api.get(ApiUrl + `signalement/recap/${id}`);
  }

  validate(id) {
    return this.api.patch(ApiUrl + `signalement/${id}/validate`);
  }

  reject(id) {
    return this.api.patch(ApiUrl + `signalement/${id}/reject`);
  }
}

export default SignalementServices;
